import type { WithStyles } from '@material-ui/core'
import { createStyles, withStyles } from '@material-ui/core'
import { AlertDialog, Typography, useDialogs } from '@paintscout/ui'
import React, { useEffect } from 'react'
import { useAuth } from 'react-auth0'
import { useLocation, type RouteComponentProps } from 'react-router-dom'
import { clearUserData } from 'shared/util/auth'

export interface LogoutProps extends WithStyles<typeof styles>, RouteComponentProps {}

const styles = createStyles({
  root: {
    height: '50vh',
    color: '#757575',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  spinner: {
    marginBottom: 40
  }
})

function Logout(props: LogoutProps) {
  const { classes } = props
  const { logout, session } = useAuth()
  const { openDialog, dismissDialog } = useDialogs()
  const location = useLocation<{ message?: string }>()

  useEffect(() => {
    document.title = 'PaintScout | Logout'

    if (location.state && location.state.message) {
      openDialog(AlertDialog, {
        title: 'Logging Out',
        message: location.state.message,
        onConfirm: () => {
          dismissDialog()
          clearUserData(session?.app_metadata?.companyId).then(() => logout())
        }
      })
    } else {
      clearUserData(session?.app_metadata?.companyId).then(() =>
        logout({ logoutParams: { returnTo: process.env.PS_APP_URL as string } })
      )
    }
  }, [])

  return (
    <div className={classes.root}>
      <Typography variant="h5">Logging out...</Typography>
    </div>
  )
}

export default withStyles(styles)(Logout)
